import { render, staticRenderFns } from "./ProductBenefit.vue?vue&type=template&id=462a6766"
import script from "./ProductBenefit.vue?vue&type=script&lang=js"
export * from "./ProductBenefit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports